<template>
  <div>
    <news-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
    >
    </news-header>
    <div class="news-detail">
      <div class="news-nav">
        <news-nav-top :hyNews="hy_news"></news-nav-top>
        <news-nav-bottom :xgNews="xg_news"></news-nav-bottom>
      </div>
      <div class="news-show">
        <news-content :news="newsInfo"></news-content>
      </div>
    </div>
    <news-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="contactInfo"
      :productType="productType"
    >
    </news-footer>
  </div>
</template>

<script>
import NewsHeader from "@/components/pc/Header";
import NewsNavTop from "@/components/pc/NewsNavTop";
import NewsNavBottom from "@/components/pc/NewsNavBottom";
import NewsContent from "@/components/pc/NewsContent";
import NewsFooter from "@/components/pc/Footer";
export default {
  name: "NewsDetail",
  props: {},
  data() {
    return {
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      imgList: [],
      topStyle: "",
      actIndex: 7,
      bottom: {},
      logo: "",
      contactInfo: {},
      newsInfo: {},
      prev: {},
      next: {},
      xg_news: [],
      hy_news: [],
      newsId: -1,
      productType: [],
      bottomNews: [],
    };
  },
  components: {
    NewsHeader,
    NewsNavTop,
    NewsNavBottom,
    NewsContent,
    NewsFooter,
  },
  watch: {
    $route() {
      this.newsId = this.$route.params.id;
      if (!this.newsId) return;
      this.getPageData();
    },
  },
  mounted() {
    this.newsId = this.$route.params.id;
  },
  created() {
    this.newsId = this.$route.params.id;
    this.getNewDetail();
  },

  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getNewDetail() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/new_detail",
        { id: this.newsId },
        (res) => {
          if (res.code == 1) {
            this.newsInfo = res.data.newsinfo;
            this.xg_news = res.data.xg_news;
            this.hy_news = res.data.hy_news;
            this.topStyle =
              "background-image:url('" +
              require("../../static/images/new_bg.png") +
              "')";
          }
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.news-detail {
  width: 70%;
  max-width: 1344px;
  min-width: 1008px;
  margin: 0 auto;
  padding: 150px 0 96px;
  overflow: hidden;

  .news-nav {
    float: left;
    margin-right: 4%;
    width: 30%;
  }

  .news-show {
    float: left;
    width: 65%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/NewsDetail.vue